export const accountEndPoints = {
  // otp
  sendOtp: '/core/send-otp',
  customerLogin: 'customer/login',
  customerLogout: 'customer/logout',
  policies: 'customer/policies',
  // policy verification
  sendPolicyOTP: '/customer/loyalty-discount/send_otp',
  verifyPolicyOTP: '/customer/loyalty-discount/verify_otp',
  sendWhatsappOtp: '/core/send-whatsapp-otp',
  verifyUser: (app: string, policyID: string) => `/${app}/verify-user/${policyID}`
};
